/**
 * 前端需要限制的高级版本功能类型
 */

export class PremiumFunctionType {
    /**
     * 订单列表加载500单
     */
    static ORDER_LIST_ORDER_NUMBER_500 = "ORDER_LIST_ORDER_NUMBER_500";

    /**
     * 订单列表加载1000单
     */
    static ORDER_LIST_ORDER_NUMBER_1000 = "ORDER_LIST_ORDER_NUMBER_1000";

    /**跨平台打单 */
    static CROSS_SHOP_PRINT = "CROSS_SHOP_PRINT";

    /**导入订单数量 */
    static ORDER_IMPORTING_ORDER_NUMBER_5000 = "ORDER_IMPORTING_ORDER_NUMBER_5000";

    /**添加微信子账号 */
    static SUB_ACCOUNT_NUMBER_5 = "SUB_ACCOUNT_NUMBER_5";

    /**添加手工店铺 */
    static MANUAL_ORDER_SHOP_NUMBER_2 = "MANUAL_ORDER_SHOP_NUMBER_2";

    /**物流异常预警设置 */
    static ORDER_LOGISTICS_WARNING = "ORDER_LOGISTICS_WARNING";

    /**查看物流异常预警订单 */
    static LOGISTICS_WARNING_ORDER_LIST = "LOGISTICS_WARNING_ORDER_LIST";

    /**拆分和取消拆分订单 */
    static ORDER_SPLITTING = "ORDER_SPLITTING";

    /**快递对账 */
    static LOGISTICS_AUDIT = "LOGISTICS_AUDIT";

    /**操作日志 */
    static OPERATION_LOG = "OPERATION_LOG";

    /**添加拼多多官方代发 */
    static ADD_PDD_FDS_SHOP = "ADD_PDD_FDS_SHOP";

    /**添加阿里巴巴官方代发 */
    static ADD_ALIBABA_SUPPLIER_SHOP = "ADD_ALIBABA_SUPPLIER_SHOP";

    /**拼多多官方代发同步 */
    static PDD_FDS_SYNC_ORDER = "PDD_FDS_SYNC_ORDER";

    /** 添加拼多多跨境店铺 */
    static ADD_PDD_FULFILLMENT_SHOP = "ADD_PDD_FULFILLMENT_SHOP";

    /**拼多多跨境订单同步 */
    static PDD_FULFILLMENT_SYNC_ORDER = "PDD_FULFILLMENT_SYNC_ORDER";

    /**爆款模式 */
    static TOP_SELLING_PRODUCT_PRINTING = "TOP_SELLING_PRODUCT_PRINTING";

    /**运单号统计 */
    static WAYBILL_STATS = "WAYBILL_STATS";

    /**预发货 */
    static PRE_SHIPPING = "PRE_SHIPPING";

    /**自动分包  */
    static MULTI_PACKAGE_PRINTING = "MULTI_PACKAGE_PRINTING";

    /**
     * 带货达人
     * @deprecated 废弃 后续转变为非高级版都可以使用
     */
    static ORDER_SEARCH_AFFILIATE_MARKETER = "ORDER_SEARCH_AFFILIATE_MARKETER";

    /** 自动评价 */
    static AUTO_RATE = "AUTO_RATE";

    /** 常用搜索 */
    static FREQUENTLY_USED_ORDER_SEARCH_CRITERIA = "FREQUENTLY_USED_ORDER_SEARCH_CRITERIA";

    /** 库存管理 */
    static WMS = "WMS";

    /**
     * 导出搜索的全部订单信息
     */
    static EXPORT_ALL_SEARCHED_ORDER_INFO = "EXPORT_ALL_SEARCHED_ORDER_INFO";

    /** 发货统计 */
    static SHIPMENT_STATS = "SHIPMENT_STATS";

    /**订单同步/导入数量限制 */
    static ORDER_VOLUME_LIMIT = "ORDER_VOLUME_LIMIT";
    /** 预估配送时效 */
    static LOGISTICS_AGING_PREDICT = "LOGISTICS_AGING_PREDICT";

    /** 黑名单 */
    static BLACKLIST = "BLACKLIST";

    /**
     * 抖店真实买家昵称打印
     */
    static DOUDIAN_BUYER_NICKNAME_PRINT = "DOUDIAN_BUYER_NICKNAME_PRINT";

    /**
     * 设置发货后多少小时内检测异常订单
     */
    static ABNORMAL_CHECK_HOURS_AFTER_ORDER_SHIPPED = "ABNORMAL_CHECK_HOURS_AFTER_ORDER_SHIPPED";
}

/** 记录因何功能点而升级的，在PremiumFunctionType的基础上新增两个值*/
export class FromFeature extends PremiumFunctionType {
    static FROM_TOP_NAV = "FROM_TOP_NAV";

    static FROM_RECORD = "FROM_RECORD";
}

export const PremiumFunctionTypeNameMap = {
    [PremiumFunctionType.ORDER_LIST_ORDER_NUMBER_500]: "订单列表加载500单",

    [PremiumFunctionType.ORDER_LIST_ORDER_NUMBER_1000]: "订单列表加载1000单",

    [PremiumFunctionType.CROSS_SHOP_PRINT]: "跨店铺打单",

    [PremiumFunctionType.ORDER_IMPORTING_ORDER_NUMBER_5000]: "导入订单数量",

    [PremiumFunctionType.SUB_ACCOUNT_NUMBER_5]: "添加微信子账号",

    [PremiumFunctionType.MANUAL_ORDER_SHOP_NUMBER_2]: "添加手工店铺",

    [PremiumFunctionType.ORDER_LOGISTICS_WARNING]: "物流异常预警设置",

    [PremiumFunctionType.LOGISTICS_WARNING_ORDER_LIST]: "查看物流异常预警订单",

    [PremiumFunctionType.ORDER_SPLITTING]: "拆分和取消拆分订单",

    [PremiumFunctionType.LOGISTICS_AUDIT]: "快递对账",

    [PremiumFunctionType.OPERATION_LOG]: "操作日志",

    [PremiumFunctionType.ADD_PDD_FDS_SHOP]: "添加拼多多官方代发",

    [PremiumFunctionType.PDD_FDS_SYNC_ORDER]: "同步拼多多官方代发订单",

    [PremiumFunctionType.PDD_FULFILLMENT_SYNC_ORDER]: "同步拼多多跨境订单",

    [PremiumFunctionType.ADD_PDD_FULFILLMENT_SHOP]: "添加拼多多跨境店铺",

    [PremiumFunctionType.TOP_SELLING_PRODUCT_PRINTING]: "爆款模式",

    [PremiumFunctionType.WAYBILL_STATS]: "运单号统计",

    [PremiumFunctionType.PRE_SHIPPING]: "预发货",

    [PremiumFunctionType.MULTI_PACKAGE_PRINTING]: "自动分包",

    [PremiumFunctionType.ORDER_SEARCH_AFFILIATE_MARKETER]: "带货达人",

    [PremiumFunctionType.AUTO_RATE]: "自动评价",

    [PremiumFunctionType.FREQUENTLY_USED_ORDER_SEARCH_CRITERIA]: "常用搜索",

    [PremiumFunctionType.WMS]: "库存管理",

    [PremiumFunctionType.EXPORT_ALL_SEARCHED_ORDER_INFO]: "导出搜索的全部订单信息",

    [PremiumFunctionType.SHIPMENT_STATS]: "发货统计",

    [PremiumFunctionType.ORDER_VOLUME_LIMIT]: "订单数量",

    [PremiumFunctionType.LOGISTICS_AGING_PREDICT]: "预估配送时效",

    [PremiumFunctionType.BLACKLIST]: "黑名单",

    [PremiumFunctionType.DOUDIAN_BUYER_NICKNAME_PRINT]: "抖店真实买家昵称打印",
};
